(() => {
  if (window.__cranKachingImages) return;
  window.__cranKachingImages = true;
  const selector = '.kaching-cart-item[data-product-handle="cran-duo"][data-line-key]';
  const images = new Map();
  const attempted = new Set();
  const observed = new WeakSet();
  let pending = false;
  let timer;

  function roots() {
    const result = [document];
    document.querySelectorAll('kaching-cart').forEach(host => {
      if (host.shadowRoot) result.push(host.shadowRoot);
    });
    return result;
  }

  function rows() {
    return roots().flatMap(root => Array.from(root.querySelectorAll(selector)));
  }

  function apply() {
    rows().forEach(row => {
      const url = images.get(row.getAttribute('data-line-key'));
      const img = row.querySelector('.kaching-cart-item__image-container .kaching-cart-item__image');
      if (!url || !img) return;
      if (img.getAttribute('src') !== url) img.setAttribute('src', url);
      if (img.hasAttribute('srcset')) img.removeAttribute('srcset');
    });
  }

  async function refresh() {
    apply();
    if (pending) return;
    const missing = rows().map(row => row.getAttribute('data-line-key'))
      .filter(key => key && !images.has(key) && !attempted.has(key));
    if (!missing.length) return;
    missing.forEach(key => attempted.add(key));
    pending = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const url = new URL(root + 'cart', location.origin);
      url.searchParams.set('sections', 'cart-drawer');
      const response = await fetch(url.href, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Cart images unavailable');
      const sections = await response.json();
      if (typeof sections['cart-drawer'] !== 'string') throw new Error('Cart section unavailable');
      const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      html.querySelectorAll('img[data-cran-duo-key]').forEach(img => {
        const key = img.getAttribute('data-cran-duo-key');
        const source = img.getAttribute('src');
        if (key && source) images.set(key, source);
      });
      apply();
    } catch (error) {
      console.warn('[CRAN] Duo image sync unavailable; keeping the original image.');
    } finally {
      pending = false;
      schedule();
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(() => {
      roots().forEach(root => observe(root === document ? document.body : root));
      refresh();
    }, 100);
  }

  function observe(root) {
    if (!root || observed.has(root)) return;
    observed.add(root);
    new MutationObserver(schedule).observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-line-key', 'data-product-handle', 'src', 'srcset']
    });
  }

  function start() {
    observe(document.body);
    schedule();
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        attempted.clear();
        schedule();
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
